export interface ITreeNodeProps
{
	nodeId: string;
	[key: string]: any;
}

export default class TreeNode
{
	id: string;
	children: TreeNode[];
	parentNode: TreeNode | null | undefined;
	itemProps: any;
	indentLevel: number;	

	constructor(props: ITreeNodeProps, parent?: TreeNode)
	{
		this.id = props.nodeId;
		this.children = [];
		this.parentNode = parent;
		this.itemProps = props;
		this.indentLevel = 0;
	}

	addChild(treeNode: TreeNode)
	{
		this.children.push(treeNode);
	}

	traverse(func: (treeNode: TreeNode) => void)
	{
		if (func && func instanceof Function)
		{
			func(this);
		}

		this.children.forEach((child) =>
		{
			child.traverse(func);
		});
	}
}
